import React from "react";
import { Navigate } from "react-router-dom";

import { isUserAuthenticated } from "../../utils/Storage";

const PublicRoute = ({ element }) => {
  const isAuthenticated = isUserAuthenticated();

  let Element;
  if (typeof element === "function") {
    Element = element;
  } else if (element && element.type) {
    Element = element.type;
  } else {
    throw new Error("Invalid element prop provided to PublicRoute.");
  }

  if (!isAuthenticated) {
    return <Element {...(element.props || {})} />;
  } else {
    return <Navigate to={"/dashboard"} replace />;
  }
};

export default PublicRoute;
